import { render, staticRenderFns } from "./NewCustomers.vue?vue&type=template&id=18147416&scoped=true&"
import script from "./NewCustomers.vue?vue&type=script&lang=js&"
export * from "./NewCustomers.vue?vue&type=script&lang=js&"
import style0 from "./NewCustomers.vue?vue&type=style&index=0&id=18147416&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18147416",
  null
  
)

export default component.exports